// action types for the pre contracts
export const SET_CONTRACTS_LIST = "SET_CONTRACTS_LIST";
export const SET_CONTRACT = "SET_CONTRACT";
export const SET_CONTRACT_ITEMS = "SET_CONTRACT_ITEMS";
export const SET_CONTRACT_ITEM = "SET_CONTRACT_ITEM";
export const SET_AVAILABLE_CONTRACT_ITEMS = "SET_AVAILABLE_CONTRACT_ITEMS";
export const SET_SOLD_CONTRACT_ITEMS = "SET_SOLD_CONTRACT_ITEMS";
export const SET_SELLER_DOCUMENTS = "SET_SELLER_DOCUMENTS";
